import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-uitkeringen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-uitkeringen.component.html',
  styleUrl: './tekst-uitkeringen.component.scss',
})
export class TekstUitkeringenComponent {}
